<template>
	<div>
		<div class="gauge" ref="gauge">
			<!-- <div class="bg"></div>
			<div class="border"></div>-->
			<div class="gauge_bg_blue_light"></div>
			<svg viewBox="0 0 100 100" class="svg">
				<defs>
					<linearGradient x1="1" y1="1" x2="0" y2="0" id="gradient_top">
						<stop offset="0%" stop-color="#f9bd3c" />
						<stop offset="100%" stop-color="#f9bd3c" />
					</linearGradient>
					<linearGradient x1="1" y1="1" x2="0" y2="0" id="gradient_top_bg">
						<stop offset="0%" stop-color="#ffff00" />
						<stop offset="100%" stop-color="#ffff00" />
					</linearGradient>
					<linearGradient x1="1" y1="1" x2="0" y2="0" id="gradient_bottom">
						<stop offset="0%" stop-color="#098a95" />
						<stop offset="100%" stop-color="#098a95" />
					</linearGradient>
					<filter id="f1">
						<feGaussianBlur in="SourceGraphic" stdDeviation="1.5" />
					</filter>
					<filter id="f2">
						<feGaussianBlur in="SourceGraphic" stdDeviation="1" />
					</filter>
				</defs>
				<!-- <circle
					filter="url(#f1)"
					r="40"
					cx="50%"
					cy="50%"
					stroke-dashoffset="218"
					class="gauge-path-current-speed"
					style="stroke: url('#gradient_bottom');stroke-dasharray: 404px;fill: transparent;stroke-width: 4px;"
					v-if="false"
				/>
				<circle
					filter="url(#f2)"
					r="40"
					cx="50%"
					cy="50%"
					:stroke-dashoffset="svgRotate"
					class="gauge-path-current-speed"
					style="stroke: url('#gradient_top_bg');stroke-dasharray: 404px;fill: transparent;stroke-width: 4px;"
					v-if="false"
				/>-->
				<circle
					filter="url(#f2)"
					r="40"
					cx="50%"
					cy="50%"
					:stroke-dashoffset="svgRotate"
					class="gauge-path-current-speed"
					style="stroke: url('#gradient_top');stroke-dasharray: 404px;fill: transparent;stroke-width: 6px;"
				/>
			</svg>
			<div class="gauge_bg"></div>
			<div class="pointer" :style="{
            transform:rotateCss
        }">
				<div
					class="pointer_line"
					v-if="isShowLine"
					:style="{
            opacity:percent/100
        }"
				></div>
				<div class="pointer_light" v-if="isShowLight"></div>
			</div>
			<div class="value_wrap" :key="index" v-for="(speed,index) in speeds">
				<div :class="'value value_'+index">{{speed}}</div>
			</div>
			<div class="isp">{{isp}}</div>
			<div class="desc">
				<div class="speed">
					<div
						class="speed_check"
						v-if="type == 'up' && !$store.state.isShowUpCheckAnimation || type == 'down' && !$store.state.isShowDownCheckAnimation"
					>检测中</div>
					<div class="speed_value" v-else>{{nowSpeed?nowSpeed:"---"}}</div>
					<div>Mbps</div>
				</div>
			</div>
			<div class="type">{{title}}</div>
		</div>
	</div>
</template>
<script>
export default {
	data: function() {
		return {
			isShowLine: false,
			isShowLight: false,
			isRendering: false,
			rotate: 0,
			cssRotate: 0,
			defaultRotate: 0,
			maxRotate: 224,
			svgRotate: 389,
			defaultSvgRotate: 389,
			maxSvgRotate: 232,
			percent: 0,
			upSpeeds: [0, 10, 20, 30, 40, 50],
			downSpeeds: [0, 100, 200, 300, 400, 500]
		};
	},
	props: ["type", "minSpeed", "maxSpeed", "isShowAction", "isp"],
	watch: {
		// "$store.state.isShowDownCheckAnimation": function(newVal, oldVal) {
		// 	if (newVal) {
		// 		this.renderAll();
		// 	}
		// },
		// "$store.state.isShowUpCheckAnimation": function(newVal, oldVal) {
		// 	if (newVal) {
		// 		this.renderAll();
		// 	}
		// }
	},
	computed: {
		rotateCss: function() {
			return "rotate(" + this.cssRotate + "deg)";
		},
		rotateLightCss: function() {
			return "rotate(" + (this.cssRotate - 20) + "deg)";
		},
		speeds: function() {
			if (this.type == "up") {
				if (this.maxSpeed == 0) {
					return [0, 10, 20, 30, 40, 50];
				} else if (this.maxSpeed <= 20) {
					return [0, 4, 8, 10, 15, 20];
				} else if (this.maxSpeed <= 30) {
					return [0, 5, 10, 15, 20, 30];
				} else {
					return [0, 10, 20, 30, 40, 50];
				}
			} else {
				if (this.maxSpeed == 0) {
					return [0, 100, 200, 300, 400, 500];
				} else if (this.maxSpeed <= 100) {
					return [0, 10, 20, 50, 70, 100];
				} else if (this.maxSpeed <= 200) {
					return [0, 20, 50, 100, 150, 200];
				} else if (this.maxSpeed <= 300) {
					return [0, 100, 150, 200, 250, 300];
				} else if (this.maxSpeed <= 500) {
					return [0, 100, 200, 300, 400, 500];
				} else {
					return [0, 200, 400, 500, 600, 700];
				}
			}
		},
		title: function() {
			if (this.type == "up") {
				return "上行提速";
			} else {
				return "下行提速";
			}
		},
		nowSpeed: function() {
			if (this.type == "down" && this.$store.state.isPayDown) {
				return this.maxSpeed;
			} else if (this.type == "up" && this.$store.state.isPayUp) {
				return this.maxSpeed;
			}
			if (
				this.type == "down" &&
				!this.$store.state.isShowDownCheckAnimation
			) {
				return 0;
			} else if (
				this.type == "up" &&
				!this.$store.state.isShowUpCheckAnimation
			) {
				return 0;
			}
			if (this.type == "up") {
				if (
					(this.$store.state.speedUpStatus == 1 &&
						this.$store.state.speedUpErrno === 0) ||
					this.$store.state.isUpTry
				) {
					return this.maxSpeed;
				} else {
					return this.minSpeed;
				}
			} else {
				if (
					(this.$store.state.speedDownStatus == 1 &&
						this.$store.state.speedDownErrno === 0) ||
					this.$store.state.isDownTry
				) {
					return this.maxSpeed;
				} else {
					return this.minSpeed;
				}
			}
		},
		maxPercent: function() {
			// if (
			// 	this.type == "down" &&
			// 	!this.$store.state.isShowDownCheckAnimation
			// ) {
			// 	return 100;
			// } else if (
			// 	this.type == "up" &&
			// 	!this.$store.state.isShowUpCheckAnimation
			// ) {
			// 	return 100;
			// }
			let speeds = this.speeds;

			let percent = 0;

			for (let i = 1; i < speeds.length; i++) {
				let item = speeds[i];
				let prevItem = speeds[i - 1];
				let thisPercent = 1 / (speeds.length - 1);
				if (this.nowSpeed <= item) {
					thisPercent =
						((this.nowSpeed - prevItem) / (item - prevItem)) *
						thisPercent;
					percent += thisPercent;
					break;
				}
				percent += thisPercent;
			}

			percent = percent > 1 ? 1 : percent;
			percent = percent < 0 ? 0 : percent;
			// console.log(percent);
			return percent * 100;
		}
	},
	methods: {
		renderAll: function() {
			let _that = this;

			if (_that.isRendering) {
				return;
			}
			// console.log(_that.type);
			// console.log("renderAll");

			if (
				_that.type == "down" &&
				!_that.$store.state.isShowDownCheckAnimation
			) {
				_that.renderCheckAnimation();
				return;
			} else if (
				_that.type == "up" &&
				!_that.$store.state.isShowUpCheckAnimation
			) {
				_that.renderCheckAnimation();
				return;
			}

			_that.renderBg(_that.percent);
			_that.renderPointer(_that.percent);
			if (_that.percent <= 0) {
				_that.isShowLine = true;
			}
			_that.isRendering = true;
			_that.startInterVal = setInterval(function() {
				if (_that.percent >= _that.maxPercent) {
					_that.percent = _that.maxPercent;
					_that.renderBg(_that.percent);
					_that.renderPointer(_that.percent);
					_that.isRendering = false;
					setTimeout(function() {
						_that.isShowLine = false;
					}, 100);
					clearInterval(_that.startInterVal);
					if (_that.isShowAction) {
						_that.startPointerAction();
					}
					return;
				}
				_that.renderBg(_that.percent);
				_that.renderPointer(_that.percent);
				_that.percent += 4;
			}, 50);
		},
		renderCheckAnimation: function() {
			let _that = this;

			if (_that.isRendering) {
				return;
			}

			if (
				this.type == "down" &&
				this.$store.state.isShowDownCheckAnimation
			) {
				return;
			} else if (
				this.type == "up" &&
				this.$store.state.isShowUpCheckAnimation
			) {
				return;
			}
			let isMax = false;
			_that.isRendering = true;
			_that.checkInterVal = setInterval(function() {
				if (_that.percent <= 0 && isMax) {
					_that.percent = 0;
					_that.renderBg(_that.percent);
					_that.renderPointer(_that.percent);
					clearInterval(_that.checkInterVal);
					setTimeout(function() {
						if (
							_that.type == "down" &&
							!_that.$store.state.isShowDownCheckAnimation
						) {
							_that.$store.state.isShowDownCheckAnimation = true;
						} else if (
							_that.type == "up" &&
							!_that.$store.state.isShowUpCheckAnimation
						) {
							_that.$store.state.isShowUpCheckAnimation = true;
						}

						_that.isRendering = false;
						_that.renderAll();
					}, 800);
				} else if (isMax) {
					_that.renderBg(_that.percent);
					_that.renderPointer(_that.percent);
					_that.percent -= 6;
				} else if (_that.percent >= 100 && !isMax) {
					_that.percent = 100;
					_that.renderBg(_that.percent);
					_that.renderPointer(_that.percent);
					setTimeout(function() {
						isMax = true;
					}, 300);
				} else {
					_that.renderBg(_that.percent);
					_that.renderPointer(_that.percent);
					_that.percent += 8;
				}
			}, 50);
		},
		startPointerAction: function() {
			let _that = this;
			setTimeout(function() {
				_that.isShowLight = true;
			}, 1000);

			// let i = 0;
			// this.interVal = setInterval(function() {
			// 	if (_that.percent <= 0) {
			// 		return;
			// 	}
			// 	i++;
			// 	let random = parseInt(Math.random() * 40) / 10 - 2;
			// 	// console.log(_that.percent);
			// 	_that.renderPointer(_that.percent + random);
			// 	_that.renderBg(_that.percent + random);
			// }, 200);
		},
		stopPointerAction: function() {
			this.isShowLight = false;
			// window.clearInterval(this.interVal);
		},
		renderSvg: function(percent) {
			this.svgRotate =
				this.defaultSvgRotate -
				(this.defaultSvgRotate - this.maxSvgRotate) * (percent / 100);
		},
		renderPointer: function(percent) {
			this.renderSvg(percent);
			this.rotate =
				this.defaultRotate +
				(this.maxRotate - this.defaultRotate) * (percent / 100);
			this.cssRotate = this.rotate;
			// this.rotateCss = "rotate(" + this.rotate + "deg)";
		},
		renderBg: function() {},
		showStartAnimation: function(cb) {
			let _that = this;
			let isMax = false;
			_that.interVal = setInterval(function() {
				// console.log(_that.percent);
				if (isMax) {
					_that.percent--;
				} else {
					_that.percent++;
				}
				_that.renderPointer(_that.percent);
				if (_that.percent === 100) {
					isMax = true;
				}
				if (_that.percent === 0) {
					clearInterval(_that.interVal);
					cb ? cb() : null;
				}
			}, 10);
		}
	},
	mounted: function() {
		// let _that = this;
		// _that.renderAll();
		// _that.showStartAnimation(function() {
		// 	_that.renderAll();
		// });
	}
};
</script>

<style lang="less" scoped>
.gauge {
	width: 750px;
	height: 500px;
	overflow: hidden;
	position: relative;
	margin: 0 auto;
	vertical-align: top;
	transform: scale(0.65);
	margin-top: -50px;
	margin-bottom: -60px;

	.gauge_canvas {
		width: 450px;
		height: 450px;
	}

	.gauge_bg_blue_light {
		width: 620px;
		height: 620px;
		display: block;
		position: absolute;
		top: -2;
		left: 65px;
		background-image: url(../assets/gauge_bg_blue_light.png);
		background-repeat: no-repeat;
		background-position: center top;
		background-size: 555px;
	}

	.gauge_bg {
		width: 620px;
		height: 620px;
		display: block;
		position: absolute;
		top: 0;
		left: 65px;
		background-image: url(../assets/gauge_bg.png);
		background-repeat: no-repeat;
		background-position: center top;
		background-size: 555px;
	}

	.svg {
		width: 620px;
		height: 620px;
		display: block;
		position: absolute;
		top: 0;
		left: 65px;
		margin-top: -35px;
		transform: rotate(137deg);
	}

	.border {
		@width: 380px;
		@border: 2px;
		height: @width;
		width: @width;
		border: @border solid #dabe8e;
		border-radius: (@width+2* @border)/2;
		position: absolute;
		left: 50%;
		margin-left: -(@width+2* @border)/2;
		top: 30px;
	}

	.pointer {
		width: 400px;
		height: 400px;
		background-image: url("../assets/pointer.png");
		background-size: 100% 100%;
		position: absolute;
		top: 78px;
		left: 175px;
		z-index: 10;

		.pointer_line {
			position: absolute;
			width: 384px;
			height: 263px;
			background-image: url("../assets/pointer_line.png");
			background-size: 100% 100%;
			top: 110px;
			left: 45px;
			transform: rotate(-224deg);
		}
		@keyframes line {
			0% {
				opacity: 1;
			}
			50% {
				opacity: 0;
			}
			100% {
				opacity: 1;
			}
		}

		.pointer_light {
			position: absolute;
			width: 285px;
			height: 330px;
			background-image: url("../assets/pointer_light.png");
			background-size: 100% 100%;
			bottom: -9px;
			left: -78px;
			transform: rotate(138deg);
			animation: light 2s infinite;
		}
		@keyframes light {
			0% {
				opacity: 0;
			}
			50% {
				opacity: 1;
			}
			100% {
				opacity: 0;
			}
		}
	}

	.value_wrap {
		width: 0;
		height: 0;
		position: absolute;
		top: 280px;
		left: 375px;
		color: #dddddd;
		font-size: 30px;
		font-weight: bolder;
		font-family: "黑体", "sans-serif", "Microsoft YaHei", "微软雅黑",
			"MicrosoftJhengHei", "华文细黑", "STHeiti";
		.value {
			position: absolute;
			top: 0;
			left: 0;
			width: 55px;
			height: 26px;
			line-height: 26px;
			text-align: center;
		}
		.value_0 {
			transform: translateX(-228px) translateY(70px) rotate(250deg);
		}
		.value_1 {
			transform: translateX(-225px) translateY(-95px) rotate(-73deg);
		}
		.value_2 {
			transform: translateX(-110px) translateY(-210px) rotate(-30deg);
		}
		.value_3 {
			transform: translateX(56px) translateY(-213px) rotate(25deg);
		}
		.value_4 {
			transform: translateX(170px) translateY(-100px) rotate(70deg);
		}
		.value_5 {
			transform: translateX(175px) translateY(60px) rotate(120deg);
		}
	}
	.isp {
		color: #dddddd;
		position: absolute;
		top: 120px;
		left: 0;
		width: 100%;
		font-size: 24px;
		text-align: center;
	}
	.desc {
		position: absolute;
		left: 0;
		top: 210px;
		color: #95f6ff;
		width: 100%;
		text-align: center;
		font-size: 28px;
		z-index: 20;
		.speed {
			color: #a59264;
			.speed_value {
				height: 90px;
				line-height: 90px;
				font-size: 70px;
				font-weight: bolder;
				color: #fccc59;
			}
			.speed_check {
				height: 90px;
				line-height: 90px;
				font-size: 40px;
				font-weight: bolder;
				color: #fccc59;
			}
		}
	}
	.type {
		color: #dddddd;
		position: absolute;
		top: 455px;
		left: 0;
		width: 100%;
		font-size: 30px;
		text-align: center;
	}
}

@media screen and (max-width: 1440px) {
	.gauge {
		transform: scale(0.6);
	}
}

@media screen and (max-width: 1280px) {
	.gauge {
		transform: scale(0.55);
	}
}

@media screen and (max-width: 1000px) {
	.gauge {
		transform: scale(0.35);
		margin-top: -160px;
		margin-bottom: -140px;
	}
}
</style>
